export default "__VITE_ASSET__3QwnRJ4v__"